
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnowShowersNight as ObiSnowShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow-showers-night.js';
 
 
 

 
 export const ObiSnowShowersNight = createComponent({
   react: React,
   tagName: 'obi-snow-showers-night',
   elementClass: ObiSnowShowersNightElement,
   events: {
     
   }
  });
 
 